import { db } from './db';
import { HCW_CATEGORIES } from '@/config/hcw-categories';
import { logger } from '@/utils/logger';

export async function seedDatabase(): Promise<void> {
  logger.info('seedDatabase: Starting...');

  try {
    const count = await db.hcw_categories.count();
    logger.info(`seedDatabase: Current category count: ${count}`);

    if (count === 0) {
      logger.info(`seedDatabase: Seeding ${HCW_CATEGORIES.length} categories...`);
      await db.hcw_categories.bulkAdd(HCW_CATEGORIES);
      const newCount = await db.hcw_categories.count();
      logger.info(`seedDatabase: Seeding complete. New count: ${newCount}`);
    } else {
      // Verify bilingual fields exist (migration may have already handled this)
      const sample = await db.hcw_categories.limit(1).first();
      if (sample && !sample.name_en) {
        logger.info('seedDatabase: Backfilling bilingual fields...');
        for (const cat of HCW_CATEGORIES) {
          await db.hcw_categories.update(cat.code, {
            name_en: cat.name_en,
            name_es: cat.name_es,
          });
        }
        logger.info('seedDatabase: Bilingual backfill complete');
      } else {
        logger.info('seedDatabase: Categories already exist with bilingual fields, skipping seed');
      }
    }
  } catch (error) {
    logger.error('seedDatabase: Error during seeding:', error);
    throw error;
  }
}
